export const HAS_PERSONAL_DATA_FORM = (clientDesignator) => {
    return {
        name: "hasPersonalDataForm",
        path: `/v1/clients/${clientDesignator}/has-personal-data-form`,
    };
};

export const AUTHENTICATE_MEMBER = (clientDesignator) => {
    return {
        name: "authenticateMember",
        path: `/v1/members/${clientDesignator}/get-member-authentication`,
    };
};

export const UPDATE_MEMBER = (clientDesignator) => {
    return {
        name: "updateMember",
        path: `/v1/members/${clientDesignator}/update-authorized-member-data`,
    };
};



// WEBPACK FOOTER //
// ./src/components/personal-data/personalDataModels.js